<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
<div class="sidebar-cmp">
  <div class="sidebar-menu">
    <div class="dock">
      <p-dock (mouseenter)="onDockHover()" (mouseleave)="onDockLeave()" position="left" [model]="navbarItems">
        <ng-template pTemplate="item" let-item let-i="index">
          <i class="dock-ico" [ngClass]="item.iconClass"></i>
          <span class="text-[10.1px] transition-opacity duration-200"
              [class.opacity-0]="!hovered()"
              [class.opacity-100]="hovered()">
            {{ item.label }}
          </span>
        </ng-template>
      </p-dock>
    </div>
  </div>

  <div class="{{ menuSelected() === '' ? '' : menuSelected() === 'wellExplorer' ? 'sidebar-sub-menu-well-explorer' : 'sidebar-sub-menu' }}">
    @if (menuSelected() === 'wellExplorer') {
      <app-well-explorer (closed)="handleClose()" [onScrollToNode]="scrollToNode()" />
    }

    @if (menuSelected() === 'wellboreInputs') {
      <app-sidebar-menu-group suffixLabel="FOR" labelColor="Red"
        [menuItems]="wellboreInputsSubMenu" (closed)="handleClose()" />
    }

    @if (menuSelected() === 'thermal') {
      <app-sidebar-menu-group suffixLabel="CAL" [menuItems]="thermalSubMenu"
        labelColor="#FF5722" (closed)="handleClose()" />
    }

    @if (menuSelected() === 'apb') {
      <app-sidebar-menu-group suffixLabel="NIX" labelColor="#4CAF50"
        [menuItems]="apbSubMenu" (closed)="handleClose()" />
    }

    @if (menuSelected() === 'stress') {
      <app-sidebar-menu-group suffixLabel="VIS" [menuItems]="stressSubMenu"
        labelColor="#00e5ff" (closed)="handleClose()" />
    }

    @if (menuSelected() === 'perimot') {
      <app-sidebar-menu-group suffixLabel="MOT" [menuItems]="perimotSubMenu"
        labelColor="#ffff00" (closed)="handleClose()" />
    }

    @if (menuSelected() === 'database') {
      <app-sidebar-menu-group solidColorLabel="Catalogs"
        [menuItems]="catalogSubMenu" (closed)="handleClose()" />
    }
  </div>
</div>
</app-tool-loader>